var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAttempts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.292,
    height: 183.982,
    viewBox: "0 0 163.292 183.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.7;}.b{fill:#d3d9dd;}.c{fill:#b1babf;}.d{fill:#fff;}.e{fill:#bec6cb;}.f{fill:#eff0f5;}.g{fill:#e9ecee;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(3145.711 2575)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3145.711 -2575)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M131.578,3V152.989a3,3,0,0,1-3,3H31.793a3,3,0,0,1-3-3v-7.66a1.994,1.994,0,0,1,1.654-1.973,10.034,10.034,0,0,0,0-19.792,1.994,1.994,0,0,1-1.654-1.973V108.353a1.994,1.994,0,0,1,1.654-1.973,10.034,10.034,0,0,0,0-19.792,1.993,1.993,0,0,1-1.654-1.973V71.377A1.993,1.993,0,0,1,30.444,69.4a10.034,10.034,0,0,0,0-19.792,1.993,1.993,0,0,1-1.654-1.973V34.4a1.994,1.994,0,0,1,1.654-1.973,10.034,10.034,0,0,0,0-19.792,1.994,1.994,0,0,1-1.654-1.973V3a3,3,0,0,1,3-3h96.783a3,3,0,0,1,3,3Z",
    transform: "translate(-28.79 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M285.556,0H273.82a3,3,0,0,1,3,3V152.989a3,3,0,0,1-3,3h11.736a3,3,0,0,0,3-3V3a3,3,0,0,0-3-3Z",
    transform: "translate(-185.771)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.69 37.036)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M159.728,108.619H105.841a2.776,2.776,0,0,1,0-5.553h53.887a2.776,2.776,0,0,1,0,5.553Z",
    transform: "translate(-103.065 -103.066)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M142.8,214.876H105.846a2.776,2.776,0,0,1,0-5.553H142.8a2.776,2.776,0,1,1,0,5.553Z",
    transform: "translate(-103.068 -171.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M159.728,321.141H105.841a2.776,2.776,0,1,1,0-5.553h53.887a2.776,2.776,0,1,1,0,5.553Z",
    transform: "translate(-103.065 -239.22)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M295.7,101.181l-30.433-38.2a11.828,11.828,0,0,0-17.347-1.252L207.3,99.873a4.636,4.636,0,0,0-.745,5.858l1.74,2.75a10.728,10.728,0,0,0,15.882,2.549L243.784,94.9a4.062,4.062,0,0,1,6.355,1.634l5.325,13.37a9.838,9.838,0,0,1-.713,8.718l-13.077,21.7v69.006h38.907V159.9L297.6,112.737a12.006,12.006,0,0,0-1.9-11.556Z",
    transform: "translate(-142.217 -37.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M375.184,101.183l-30.433-38.2A11.833,11.833,0,0,0,329.9,59.935a11.784,11.784,0,0,1,3.658,3.053L364,101.183a12,12,0,0,1,1.9,11.556L348.879,159.9V209.33h11.187V159.9l17.021-47.166a12.006,12.006,0,0,0-1.9-11.556Z",
    transform: "translate(-221.702 -37.498)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M134.872,252.732a2.777,2.777,0,0,1-1.391-5.181l14.26-8.232a2.776,2.776,0,1,1,2.776,4.809l-14.26,8.232a2.763,2.763,0,0,1-1.385.372Z",
    transform: "translate(-94.972 -153.083)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.632 23.096)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M445.5,65.077l-7.109,4.1,6,10.387,7.109-4.1a6,6,0,1,0-6-10.387Z",
    transform: "translate(-340.836 -64.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M261.055,72.138l-89.466,51.653A9.356,9.356,0,1,0,180.945,140l89.466-51.653a2,2,0,0,0,.731-2.726l-7.36-12.749a2,2,0,0,0-2.726-.73Z",
    transform: "translate(-166.909 -69.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M271.167,98l-3.928-6.8a2.247,2.247,0,0,1-.512,3.105l-89.466,51.654c-3.144,1.815-7.128,1.2-10.313-1.211a9.355,9.355,0,0,0,14.022,7.635l89.466-51.653A2,2,0,0,0,271.167,98Z",
    transform: "translate(-166.935 -81.519)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M241.957,246.773,226.781,238.1a14.621,14.621,0,0,1-5.383-5.34l-19.527-33.546a9.936,9.936,0,0,1,16.326-11.23l14.468,17.968s27.213,6.969,26.549,7.632S241.957,246.773,241.957,246.773Z",
    transform: "translate(-138.811 -118.061)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M286.493,375.946V387.22l26.307,3.593,26.307-3.593V375.946a3.412,3.412,0,0,0-3.412-3.412h-45.79A3.412,3.412,0,0,0,286.493,375.946Z",
    transform: "translate(-197.843 -238.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M404.326,372.534H393.619a3.412,3.412,0,0,1,3.412,3.412V387.22h10.707V375.946A3.411,3.411,0,0,0,404.326,372.534Z",
    transform: "translate(-266.474 -238.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M266.15,446.983V417.849A4.445,4.445,0,0,1,270.6,413.4h58.344a4.445,4.445,0,0,1,4.445,4.445v29.134a1.851,1.851,0,0,1-1.851,1.851H268A1.851,1.851,0,0,1,266.15,446.983Z",
    transform: "translate(-184.81 -264.851)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M421.794,413.4H411.087a4.445,4.445,0,0,1,4.445,4.445v30.985h8.856a1.851,1.851,0,0,0,1.851-1.851V417.849A4.445,4.445,0,0,0,421.794,413.4Z",
    transform: "translate(-277.665 -264.851)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAttempts);
export default __webpack_public_path__ + "static/media/no-attempts.e9e679a25b6f766477e0c4ef46fa1370.svg";
export { ForwardRef as ReactComponent };